import { createSlice } from '@reduxjs/toolkit'
import { RootState, AppThunk } from './store'
import { post } from 'utils/rest'
import * as Toast from 'components/Toast'

export interface RegistrationRequestState {
  isLoading: boolean
  isSubmitted: boolean
  hasError: boolean
  errorMessage: string | null
}

const createInitialState = (): RegistrationRequestState => ({
  isLoading: false,
  isSubmitted: false,
  hasError: false,
  errorMessage: null,
})

export const registrationRequestSlice = createSlice({
  name: 'registrationRequest',
  initialState: createInitialState(),
  reducers: {
    submitting: (state) => {
      state.isLoading = true
      state.isSubmitted = false
      state.hasError = false
      state.errorMessage = null
    },
    submitSuccess: (state) => {
      state.isLoading = false
      state.isSubmitted = true
      state.hasError = false
      state.errorMessage = null
    },
    submitFail: (state, action) => {
      state.isLoading = false
      state.isSubmitted = false
      state.hasError = true
      state.errorMessage = action.payload ?? null
    },
    reset: () => createInitialState(),
  },
})

export const { submitting, submitSuccess, submitFail, reset } = registrationRequestSlice.actions

export const selectRegistrationRequestState = (state: RootState) => state.registrationRequest

export interface RegistrationRequestInput {
  email: string
  password: string
  organisationName: string
}

export const submitRegistrationRequestAsync =
  (input: RegistrationRequestInput): AppThunk =>
  async (dispatch) => {
    dispatch(submitting())
    try {
      const response = await post<boolean>('/api/registrationrequest', input)

      if (response.status === 200 && response.parsedBody?.data === true) {
        dispatch(submitSuccess())
      } else {
        const message = response.parsedBody?.message ?? null
        dispatch(submitFail(message))
        if (message) {
          Toast.dispatchToastError({ message })
        }
      }
    } catch {
      dispatch(submitFail(null))
    }
  }

export default registrationRequestSlice.reducer
